<template>
<span>
<span v-if="loading"><i class="fas fa-spinner fa-spin"></i></span>
<b v-else>{{formattedPrice(balance)}}</b>
</span>
</template>

<script>
export default {

  data() {
    return {
      balance: null,
      loading: false,
    };
  },

  created() {
    this.getBalance();
  },

  methods: {

    getBalance() {

      this.loading = true;

      axios
        .get('/balance')
        .then((response) => {
          this.balance = response.data;
          this.loading = false;
        });

    },

  },
};
</script> 
